'use client';

import React from 'react';
import { OrganisationSelector } from '@/components/portal/OrganisationSelector';
import { UserSelector } from '@/components/portal/UserSelector';

type UserLike = { id?: string } | null;

interface ScopedOrgMemberToolbarExtrasProps {
  renderCustomToolbarHeader?: () => React.ReactNode;
  hasDefaultToolbarSelectors: boolean;
  showOrganisationSelector: boolean;
  showUserSelector: boolean;
  selectedOrgId: string | null;
  selectedUser: unknown;
  activeOrgId?: string;
  onOrgSelect: (orgId: string | null) => void;
  onUserSelect: (user: UserLike) => void;
}

function ScopedOrgMemberToolbarExtras({
  renderCustomToolbarHeader,
  hasDefaultToolbarSelectors,
  showOrganisationSelector,
  showUserSelector,
  selectedOrgId,
  selectedUser,
  activeOrgId,
  onOrgSelect,
  onUserSelect,
}: ScopedOrgMemberToolbarExtrasProps) {
  return (
    <>
      {renderCustomToolbarHeader?.()}
      {hasDefaultToolbarSelectors && (
        <>
          {showOrganisationSelector && (
            <OrganisationSelector
              selectedOrgId={selectedOrgId}
              onSelect={onOrgSelect}
              pill
            />
          )}
          {showUserSelector && (
            <UserSelector
              selectedMember={selectedUser as any}
              onSelect={onUserSelect}
              organisationId={activeOrgId}
              pill
            />
          )}
        </>
      )}
    </>
  );
}

export function createScopedOrgMemberToolbarExtras(props: ScopedOrgMemberToolbarExtrasProps) {
  if (!props.renderCustomToolbarHeader && !props.hasDefaultToolbarSelectors) {
    return undefined;
  }

  return () => <ScopedOrgMemberToolbarExtras {...props} />;
}
